<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-container>
      <v-row>
        <v-col lg="12">
          <patient-info :presumptiveDataEach="presumptiveDataEach" />
          <div
            v-for="(diagonsis, i) in presumptiveDataEach.diagonsis"
            :key="i"
            class="mt-5"
          >
            <times :diagonsis="diagonsis" />
          </div>

          <v-card class="mt-5 card--shadow">
            <v-row justify="center">
              <v-col lg="2">
                <v-btn
                  @click="goToNewTime"
                  rounded
                  depressed
                  block
                  color="teal accent-4"
                  dark
                >
                  <v-icon left dark>mdi-plus-circle-outline</v-icon>Add new
                  Times
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import PatientInfo from "@/components/presumptive/patient/PatientInfo";
import Times from "@/components/presumptive/patient/Times";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    PatientInfo,
    Times,
    SpinnerContainer,
    BackBtn,
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveDataEach"]),
    ...mapState("Loading", ["loading"]),
  },
  created() {
    this.$store.dispatch(
      "Presumptive/getPresumptiveEach",
      this.$route.params.id
    );
  },
  methods: {
    goToNewTime() {
      this.$router.push({
        name: "add-presumptive-times",
        params: {
          id: this.$route.params.id,
          township_id: this.presumptiveDataEach.township_id,
          type: JSON.stringify({
            type: "Times",
          }),
        },
      });
    },
  },
};
</script>
